module.exports = __webpack_public_path__ + "img/p01.09070fd4.jpg";